module.exports = __webpack_public_path__ + "img/uz.fc57ba6a.svg";